import { IMeasurementData } from "common/records/Measurement";
import { IOpeningData } from "common/records/Opening";
import { FormUpdateEvent } from "common/reducers/rsfForm.actions";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const FETCH_MEASUREMENT = "@measurements/FETCH_MEASUREMENT";
export const RECEIVE_MEASUREMENT = "@measurements/RECEIVE_MEASUREMENT";
export const SET_MEASUREMENT_LOADED = "@measurements/SET_MEASUREMENT_LOADED";
export const SET_MEASUREMENT_EDITING = "@measurements/SET_MEASUREMENT_EDITING";
export const RESET_MEASUREMENT = "@measurements/RESET_MEASUREMENT";
export const UPDATE_MEASUREMENT = "@measurements/UPDATE_MEASUREMENT";
export const UPDATE_ROOF_WASTE = "@measurements/UPDATE_ROOF_WASTE";
export const UPDATE_SIDING_WASTE = "@measurements/UPDATE_SIDING_WASTE";
export const UPDATE_SLOPED_ROOF_WASTE = "@measurements/UPDATE_SLOPED_ROOF_WASTE";
export const UPDATE_LINE_MEASUREMENTS = "@measurements/UPDATE_LINE_MEASUREMENTS";
export const UPDATE_RAPID_AREA = "@measurements/UPDATE_RAPID_AREA";
export const UPDATE_LEAFLET = "@measurements/UPDATE_LEAFLET";
export const UPDATE_LEAFLET_ZOOM = "@measurements/UPDATE_LEAFLET_ZOOM";
export const CREATE_FROM_ADD_MEASUREMENT_MODAL = "@measurements/CREATE_FROM_ADD_MEASUREMENT_MODAL";
export const ADD_WIZARD_OPENINGS = "@measurements/ADD_WIZARD_OPENINGS";
export const APPEND_ELEVATION_ID = "@measurements/APPEND_ELEVATION_ID";
export const REMOVE_ELEVATION_ID = "@measurements/REMOVE_ELEVATION_ID";
export const APPEND_WINDOW_ID = "@measurements/APPEND_WINDOW_ID";
export const APPEND_DOOR_ID = "@measurements/APPEND_DOOR_ID";

export const MeasurementActions = {
  fetchMeasurement: (measurementId: number) => createAction(FETCH_MEASUREMENT, { measurementId }),
  receiveMeasurement: (measurement: Partial<IMeasurementData>) => createAction(RECEIVE_MEASUREMENT, { measurement }),
  setMeasurementLoaded: (measurementId: number) => createAction(SET_MEASUREMENT_LOADED, { measurementId }),
  setMeasurementEditing: (editing: boolean) => createAction(SET_MEASUREMENT_EDITING, { editing }),
  resetMeasurement: () => createAction(RESET_MEASUREMENT),
  updateMeasurement: (event: FormUpdateEvent) => createAction(UPDATE_MEASUREMENT, { event }),
  updateRoofWaste: () => createAction(UPDATE_ROOF_WASTE, {}),
  updateSidingWaste: () => createAction(UPDATE_SIDING_WASTE, {}),
  updateSlopedRoofWaste: () => createAction(UPDATE_SLOPED_ROOF_WASTE, {}),
  updateLineMeasurements: () => createAction(UPDATE_LINE_MEASUREMENTS, {}),
  updateRapidArea: (event: FormUpdateEvent) => createAction(UPDATE_RAPID_AREA, { event }),
  updateLeaflet: (event: any) => createAction(UPDATE_LEAFLET, { event }),
  updateLeafletZoom: (zoom: number) => createAction(UPDATE_LEAFLET_ZOOM, { zoom }),
  createFromAddMeasurementModal: (type: "door" | "window" | "room") =>
    createAction(CREATE_FROM_ADD_MEASUREMENT_MODAL, { type }),
  addWizardOpenings: (kind: "window" | "door", opening: Partial<IOpeningData>, quantity: number) =>
    createAction(ADD_WIZARD_OPENINGS, { kind, opening, quantity }),
  appendElevationId: (elevationId: number) => createAction(APPEND_ELEVATION_ID, { elevationId }),
  removeElevationId: (elevationId: number) => createAction(REMOVE_ELEVATION_ID, { elevationId }),
  appendWindowId: (windowId: number) => createAction(APPEND_WINDOW_ID, { windowId }),
  appendDoorId: (doorId: number) => createAction(APPEND_DOOR_ID, { doorId }),
};

export type MeasurementActions = ActionsUnion<typeof MeasurementActions>;
